import React from 'react';

export const LANGS = [
  { id: 'hu', label: 'Magyar' },
  { id: 'en', label: 'English' },
  { id: 'ro', label: 'Română' },
];

const STORAGE_KEY = 'siteLang';

const DICT = {
  hu: {
    nav_services: 'Szolgáltatásaink',
    nav_promos: 'Aktuális / Akciók',
    nav_refs: 'Referenciák',
    nav_faq: 'GYIK',
    nav_contact: 'Kapcsolat',
    nav_quote: 'Ajánlatkérés',
    nav_menu: 'Menü',
    nav_close: 'Bezárás',
    nav_open_menu: 'Menü megnyitása',
    nav_close_menu: 'Menü bezárása',
    landing_partners: 'Partnereink',
    landing_reviews: 'Ügyfeleink mondták',
    gdpr_consent_before: 'Elolvastam és elfogadom az',
    gdpr_consent_link: 'Adatkezelési tájékoztatót',
    gdpr_consent_after:
      ', és hozzájárulok személyes adataim kezeléséhez az ajánlatkérés és kapcsolattartás céljából.',
    gdpr_consent_required: 'Az adatkezelési tájékoztató elfogadása kötelező.',
    footer_rights: 'Minden jog fenntartva.',
    footer_legal_nav: 'Jogi információk',
    footer_privacy: 'Adatkezelési tájékoztató',
    footer_cookie_settings: 'Sütibeállítások',
    cookie_banner_title: 'Fontosnak tartjuk az adatok védelmét',
    cookie_banner_body:
      'A böngészési élmény fokozása, a személyre szabott tartalmak megjelenítése, valamint a forgalom elemzése érdekében sütiket (cookie-kat) használunk. Részletek az',
    cookie_banner_privacy_link: 'Adatkezelési tájékoztatóban',
    cookie_customize: 'Testreszabás',
    cookie_reject: 'Elutasít',
    cookie_accept_all: 'Az összes elfogadása',
    cookie_prefs_title: 'Engedélyek beállítása',
    cookie_close: 'Bezárás',
    cookie_prefs_intro:
      'A sütik segítenek a navigációban és egyes funkciók működtetésében. A szükséges sütik nélkül az oldal nem használható megfelelően; a többi kategóriát az alábbiak szerint állíthatod.',
    cookie_cat_necessary: 'Szükséges',
    cookie_cat_necessary_desc:
      'Ezek a sütik elengedhetetlenek a weboldal alapvető működéséhez és biztonságához, és nem kapcsolhatók ki.',
    cookie_always_active: 'Mindig aktív',
    cookie_cat_functional: 'Funkcionális',
    cookie_cat_functional_desc:
      'Segítenek bizonyos funkciókban (pl. beállítások megjegyzése, űrlapok kényelmesebb kitöltése).',
    cookie_cat_analytics: 'Analitika',
    cookie_cat_analytics_desc:
      'Segítenek megérteni, hogyan használják a látogatók az oldalt (pl. forgalom, népszerű oldalak).',
    cookie_cat_ads: 'Hirdetés',
    cookie_cat_ads_desc:
      'Személyre szabott hirdetések megjelenítéséhez és kampányok méréséhez használhatók.',
    cookie_save: 'Beállítások mentése',
    contact_err_name: 'Add meg a neved.',
    contact_err_email: 'Érvényes e-mail címet adj meg.',
    contact_err_phone: 'Add meg a telefonszámod.',
    contact_err_message: 'Írj üzenetet.',
    contact_success: 'Köszönjük! Hamarosan felvesszük veled a kapcsolatot.',
    not_found_home: 'Főoldal',
    not_found_title: 'Az oldal nem található',
    not_found_desc:
      'Úgy tűnik, a keresett oldal nem érhető el, áthelyezték vagy már nem létezik.',
    not_found_back: 'Vissza a főoldalra',
  },
  en: {
    nav_services: 'Our services',
    nav_promos: 'Deals',
    nav_refs: 'Partners',
    nav_faq: 'FAQ',
    nav_contact: 'Contact',
    nav_quote: 'Get a quote',
    nav_menu: 'Menu',
    nav_close: 'Close',
    nav_open_menu: 'Open menu',
    nav_close_menu: 'Close menu',
    landing_partners: 'Our partners',
    landing_reviews: 'What clients say',
    gdpr_consent_before: 'I have read and accept the',
    gdpr_consent_link: 'Privacy Policy',
    gdpr_consent_after: ' and consent to the processing of my personal data for quote requests and contact.',
    gdpr_consent_required: 'You must accept the privacy policy.',
    footer_rights: 'All rights reserved.',
    footer_legal_nav: 'Legal',
    footer_privacy: 'Privacy policy',
    footer_cookie_settings: 'Cookie settings',
    cookie_banner_title: 'We care about your data',
    cookie_banner_body:
      'We use cookies to improve your experience, show relevant content, and analyse traffic. For details see our',
    cookie_banner_privacy_link: 'Privacy Policy',
    cookie_customize: 'Customize',
    cookie_reject: 'Reject',
    cookie_accept_all: 'Accept all',
    cookie_prefs_title: 'Cookie preferences',
    cookie_close: 'Close',
    cookie_prefs_intro:
      'Necessary cookies are required for the site to work. You can enable or disable optional categories below.',
    cookie_cat_necessary: 'Necessary',
    cookie_cat_necessary_desc: 'Essential for basic site operation and security. Always on.',
    cookie_always_active: 'Always active',
    cookie_cat_functional: 'Functional',
    cookie_cat_functional_desc: 'Remember preferences and improve forms or embedded features.',
    cookie_cat_analytics: 'Analytics',
    cookie_cat_analytics_desc: 'Help us understand how visitors use the site.',
    cookie_cat_ads: 'Advertising',
    cookie_cat_ads_desc: 'Used for personalised ads and measuring campaigns.',
    cookie_save: 'Save settings',
    contact_err_name: 'Please enter your name.',
    contact_err_email: 'Please enter a valid email.',
    contact_err_phone: 'Please enter your phone number.',
    contact_err_message: 'Please enter a message.',
    contact_success: 'Thank you! We will get back to you soon.',
    not_found_home: 'Home',
    not_found_title: 'Page not found',
    not_found_desc: 'The page you are looking for is unavailable, has moved, or no longer exists.',
    not_found_back: 'Back to home',
  },
  ro: {
    nav_services: 'Serviciile noastre',
    nav_promos: 'Oferte',
    nav_refs: 'Parteneri',
    nav_faq: 'Întrebări frecvente',
    nav_contact: 'Contact',
    nav_quote: 'Cere ofertă',
    nav_menu: 'Meniu',
    nav_close: 'Închide',
    nav_open_menu: 'Deschide meniul',
    nav_close_menu: 'Închide meniul',
    landing_partners: 'Partenerii noștri',
    landing_reviews: 'Ce spun clienții',
    gdpr_consent_before: 'Am citit și accept',
    gdpr_consent_link: 'Politica de confidențialitate',
    gdpr_consent_after:
      ' și îmi exprim acordul pentru prelucrarea datelor mele personale în scopul solicitării ofertei și contactului.',
    gdpr_consent_required: 'Trebuie să acceptați politica de confidențialitate.',
    footer_rights: 'Toate drepturile rezervate.',
    footer_legal_nav: 'Informații legale',
    footer_privacy: 'Politica de confidențialitate',
    footer_cookie_settings: 'Setări cookie',
    cookie_banner_title: 'Protejăm datele tale',
    cookie_banner_body:
      'Folosim cookie-uri pentru experiență mai bună, conținut relevant și analiza traficului. Detalii în',
    cookie_banner_privacy_link: 'Politica de confidențialitate',
    cookie_customize: 'Personalizare',
    cookie_reject: 'Respinge',
    cookie_accept_all: 'Acceptă toate',
    cookie_prefs_title: 'Setări permisiuni',
    cookie_close: 'Închide',
    cookie_prefs_intro:
      'Cookie-urile necesare sunt obligatorii pentru funcționarea site-ului. Celelalte categorii pot fi activate mai jos.',
    cookie_cat_necessary: 'Necesare',
    cookie_cat_necessary_desc: 'Esențiale pentru funcționarea și securitatea site-ului.',
    cookie_always_active: 'Mereu active',
    cookie_cat_functional: 'Funcționale',
    cookie_cat_functional_desc: 'Memorează preferințe și îmbunătățesc formularele.',
    cookie_cat_analytics: 'Analiză',
    cookie_cat_analytics_desc: 'Ne ajută să înțelegem cum este folosit site-ul.',
    cookie_cat_ads: 'Publicitate',
    cookie_cat_ads_desc: 'Pentru reclame personalizate și măsurarea campaniilor.',
    cookie_save: 'Salvează setările',
    contact_err_name: 'Introduceți numele.',
    contact_err_email: 'Introduceți un e-mail valid.',
    contact_err_phone: 'Introduceți numărul de telefon.',
    contact_err_message: 'Scrieți un mesaj.',
    contact_success: 'Mulțumim! Vă vom contacta în curând.',
    not_found_home: 'Pagina principală',
    not_found_title: 'Pagina nu a fost găsită',
    not_found_desc:
      'Se pare că pagina căutată nu este disponibilă, a fost mutată sau nu mai există.',
    not_found_back: 'Înapoi la pagina principală',
  },
};

function safeLang(id) {
  return LANGS.some((l) => l.id === id) ? id : 'hu';
}

const I18nContext = React.createContext({
  lang: 'hu',
  setLang: () => {},
  t: (key) => key,
});

export function I18nProvider({ children }) {
  const [lang, setLangState] = React.useState(() => {
    try {
      return safeLang(window.localStorage.getItem(STORAGE_KEY) || 'hu');
    } catch {
      return 'hu';
    }
  });

  const setLang = React.useCallback((next) => {
    const normalized = safeLang(next);
    setLangState(normalized);
    try {
      window.localStorage.setItem(STORAGE_KEY, normalized);
    } catch {
      // ignore
    }
  }, []);

  const t = React.useCallback(
    (key) => {
      const table = DICT[lang] || DICT.hu;
      return table[key] || DICT.hu[key] || key;
    },
    [lang],
  );

  const value = React.useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);

  React.useEffect(() => {
    try {
      document.documentElement.lang = lang === 'ro' ? 'ro' : lang === 'en' ? 'en' : 'hu';
    } catch {
      // ignore (SSR / tests)
    }
  }, [lang]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return React.useContext(I18nContext);
}

